<template>
  <div class="comp-container">
    <!-- <CoursewareList class="courseware-list" /> -->
    <div class="controll-box">
      <PageController v-if="!isVideo" />
      <ScaleController />
    </div>
    <img
      v-if="!isVideo"
      class="arrow-left arrow"
      :class="{ 'is-disabled': this.currentPage <= 1 }"
      src="../../assets/images/arrow-left_white.png"
      alt=""
      @click="handlePrePage"
    />
    <img
      v-if="!isVideo"
      class="arrow-right arrow"
      :class="{ 'is-disabled': this.currentPage >= this.totalPages }"
      src="../../assets/images/arrow-right_white.png"
      alt=""
      @click="handleNextPage"
    />
  </div>
</template>

<script>
// import CoursewareList from "./CoursewareList.vue";
import ScaleController from "../components/ScaleController.vue";
import PageController from "../components/PageController.vue";
import { mapState } from "vuex";
export default {
  props: {
    isVideo: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    // CoursewareList,
    ScaleController,
    PageController,
  },
  data() {
    return {
      currentPage: 1,
      totalPages: 1,
    };
  },
  computed: {
    ...mapState("live", ["whiteBoardService", "isHXApp"]),
    isLastPage() {
      return this.currentPage === this.totalPages;
    },
  },
  watch: {
    "$store.state.whiteBoard.currentFileInfo": {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.currentPage = newValue.currentPageIndex + 1;
          this.totalPages = newValue.pageCount;
        }
      },
    },
  },
  methods: {
    handleNextPage() {
      if (this.currentPage < this.totalPages) {
        this.whiteBoardService.nextBoard();
      }
    },
    handlePrePage() {
      if (this.currentPage > 1) {
        this.whiteBoardService.prevBoard();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container {
  display: flex;
  z-index: 9;
}
.courseware-list {
  position: absolute;
  bottom: 64px;
  right: 20px;
}
.controll-box {
  position: absolute;
  right: 20px;
  bottom: 12px;
  display: flex;
  align-items: center;
}
.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  cursor: pointer;
  &.arrow-left {
    left: 103px;
  }
  &.arrow-right {
    right: 103px;
  }
  &.is-disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: auto;
  }
}
</style>
